import { render, staticRenderFns } from "./ProgramPhaseHeader.vue?vue&type=template&id=7d6339f7&"
import script from "./ProgramPhaseHeader.vue?vue&type=script&lang=js&"
export * from "./ProgramPhaseHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports